import { MAIN_DOMAIN_URL, LOCAL_BACKEND } from "../configs/api.urls";

export const APP_URL = "https://mylocatorplus.com/web2020";
// export const ASSETS_URL = "https://mylocatorplus.com/web/assets";
export const ASSETS_URL = `${MAIN_DOMAIN_URL}/web/assets`;
export const TASK_ASSETS_URL = `${MAIN_DOMAIN_URL}/task-manager/assets`;
// export const TASK_ASSETS_URL = `${LOCAL_BACKEND}/task-manager/assets`;

// when uploading change here